module.exports = __webpack_public_path__ + "a4ba173f.png";